import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { registerSyncTriggers, syncOfflineQueue } from './services/offlineVoiceQueue';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register offline voice note sync triggers (visibility change, online event, initial sync)
registerSyncTriggers();

// Register THE service worker (src/service-worker.ts, built to /service-worker.js):
// caching, voice-note and delivery Background Sync, and push - one worker, because a
// scope holds one registration and two workers silently replaced each other.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      console.log('[SW] Registered:', registration.scope);

      // Check for updates on every page load
      registration.update();

      // When a new service worker is waiting, activate it immediately
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              // New version activated — reload to get fresh assets
              console.log('[SW] New version activated, reloading...');
              window.location.reload();
            }
          });
        }
      });
    }).catch(err => {
      console.log('[SW] Registration failed:', err);
    });
  });

  // Listen for background sync completion messages from SW
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'OFFLINE_NOTES_SYNCED') {
      syncOfflineQueue(); // Re-run client-side sync to update UI counts
      window.dispatchEvent(new CustomEvent('offline-notes-synced', { detail: { count: 1 } }));
    }
  });
}
